module.exports = __webpack_public_path__ + "img/login_bg2.d28daf6b.png";